import { render, staticRenderFns } from "./productMobil.vue?vue&type=template&id=36e9a592&"
import script from "./productMobil.vue?vue&type=script&lang=ts&"
export * from "./productMobil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports